// Mirror of homebase_apis/my_homepal_api/services/mcp/access.ts — the backend
// is the source of truth, this helper just hides UI clients that would 403
// anyway. MCP is a licensed feature: enabled per customer via the allow_mcp
// flag, toggled by Homepal on the internal customer page (delivered to the
// portal inside the personalized payload's allow_access object). Same
// behavior in every environment.
export interface McpCustomerLike {
  allow_access?: { allow_mcp?: boolean } | null
}

export const isMcpEnabledForCustomer = (
  customer: McpCustomerLike | null | undefined
): boolean => {
  return Boolean(customer?.allow_access?.allow_mcp)
}
